<script setup lang="ts">
import { onKeyDown } from '@vueuse/core'
import type { DartsThrow } from '~/stores/localGameStore'

const emit = defineEmits<{ close: [] }>()

const props = defineProps<{
  dartsThrow: DartsThrow
  playerName: string
  onConfirm: () => void
}>()

onKeyDown('Enter', (e) => {
  e.preventDefault()
  e.stopPropagation()
  confirm()
})

onKeyDown('Backspace', () => {
  cancel()
})

onKeyDown('Escape', () => {
  cancel()
})

function confirm() {
  props.onConfirm()
  emit('close')
}

function cancel() {
  emit('close')
  console.log('EmitClose')
}
</script>

<template>
  <UiAlertDialog :open="true">
    <UiAlertDialogContent @escape-key-down="cancel">
      <UiAlertDialogHeader>
        <UiAlertDialogTitle class="text-4xl">
          {{ $t('Remove last throw of {amount} by {playerName}', { amount: props.dartsThrow.s, playerName }) }}
        </UiAlertDialogTitle>
        <UiAlertDialogDescription>
          {{ $t('This action cannot be undone.') }}
        </UiAlertDialogDescription>
      </UiAlertDialogHeader>
      <UiAlertDialogFooter>
        <UiButton
          variant="success"
          class="sm:mr-auto"
          size="huge"
          @click="confirm"
        >
          {{ $t('Yes') }}
        </UiButton>
        <UiButton
          variant="destructive"
          size="huge"
          @click="cancel"
        >
          {{ $t('No') }}
        </UiButton>
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>
